export enum QuickActions {
  Hashtags = 'hashtags',
  Rephrase = 'rephrase',
  Spelling = 'spelling',
  Shorten = 'shorten',
  Lengthen = 'lengthen',
  Facebook = 'Facebook',
  X = 'X',
  Instagram = 'Instagram',
  GMB = 'Google Business',
  LinkedIn = 'LinkedIn',
  Pinterest = 'Pinterest',
  Tiktok = 'TikTok',
  Threads = 'Threads',
  Bluesky = 'Bluesky',
  WordPress = 'WordPress',
  YouTube = 'YouTube',
}

export enum Errors {
  QuickActionError = 'action_error',
  PromptError = 'prompt_error',
  GenericError = 'generic_error',
}
